<template>
  <div class="fill-height d-flex align-center flex-column justify-center">
    <div class="text-center w-100 px-4" style="max-width: 500px; margin: 0 auto; overflow-wrap: break-word">
      <app-icon-ds icon="file-xmark" size="xl" />
      <h4 class="mt-4">{{ $t('common.DocumentViewer.loadingDocumentError.title') }}</h4>
      <!-- Errors from pdf.js -->
      <p class="my-4" v-if="fileFromPdfjsError">
        <template v-if="errorCode === 'InvalidPDFException'">
          {{ $t('common.DocumentViewer.loadingDocumentError.invalidFormat', { fileName: fileName }) }}
        </template>
        <template v-else>
          <template v-if="fileName">
            {{ $t('common.DocumentViewer.loadingDocumentError.technicalErrorWithFile', { fileName: fileName }) }}
          </template>
          <template v-else>
            {{ $t('common.DocumentViewer.loadingDocumentError.technicalError') }}
          </template>
        </template>
      </p>
      <!-- Errors from our server -->
      <p v-else class="my-4">
        <template v-if="errorCode === 'ERR_NOT_FOUND'">
          {{ $t('common.DocumentViewer.loadingDocumentError.fileNotFound') }}  
        </template>
        <template v-else>
          {{ $t('common.DocumentViewer.loadingDocumentError.genericError') }}
        </template>
      </p>

      <app-button
        class="mx-auto"
        type="outlined"
        variant="neutral"
        @click="closeViewer"
      >
        {{ $t('common.DocumentViewer.closeViewer') }}
      </app-button>
    </div>
  </div>
</template>

<script>
import { ROOMS_ROUTE_NAME } from '@/router'

export default {
  name: 'DocumentViewerErrors',
  props: {
    fileName: {
      type: String,
      default: '',
    },
    fileFromPdfjsError: {
      type: [Object, null],
      default: null,
    },
    errorCode: {
      type: String,
      default: '',
    },
  },
  methods: {
    closeViewer () {
      if (window.opener) {
        window.close()
      } else {
        // The browser does not support window.close() if the window was not opened by JS
        // (e.g. user opened manually a new tab)
        // In this case, we redirect the user to the rooms page
        this.$router.replace({ name: ROOMS_ROUTE_NAME })
      }
    },
  },
}
</script>
